/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpsertTaskRequest} from '@cash-web/protos/squareup/stafftasks/endpoints/upsert-task.pb'
import {UpsertTaskResponse} from '@cash-web/protos/squareup/stafftasks/endpoints/upsert-task.pb'


export const upsertTask = (request: UpsertTaskRequest, options?: CashRequestOptions) => post<UpsertTaskRequest, UpsertTaskResponse>("/proxy/services/squareup.stafftasks.service.StaffTasksService/UpsertTask", request, {...options, rejectOnError: true })